import type { OrgCustomColors } from '@cognitoforms/types/server-types/model/org-custom-colors';
import { serviceRequest } from '../service-request';

export async function setOrgAppearanceColors(colors: OrgCustomColors, hasCustomColors: boolean) {
	return serviceRequest('svc/settings/org-appearance/colors', { colors, hasCustomColors }, { method: 'POST' });
}

export async function setOrgDefaultTypeface(useDefaultTypeface: boolean) {
	return serviceRequest('svc/settings/org-appearance/default-typeface', { useDefaultTypeface }, { method: 'POST' });
}

export async function setOrgAppearanceLogo(file: File) {
	const formData = new FormData();
	formData.append('_file', file);
	return serviceRequest('svc/settings/org-appearance/logo', formData, { useSubmissionToken: true });
}

export async function getOrgAppearanceSettingsFromCode(orgCode: string) {
	return serviceRequest('svc/settings/org-appearance', null, { method: 'GET', query: { orgCode } });
}

export async function deleteOrgAppearanceLogo() {
	return serviceRequest('svc/settings/org-appearance/logo', {}, { method: 'DELETE', useSubmissionToken: true });
}